import { apiClient } from "./client";

/**
 * Builds the CRUD calls for a DRF router endpoint.
 *
 * `deletable` mirrors the API: a client has no DELETE route, so `clientsApi` has
 * no `remove` to call. Discharging one is an ordinary status update.
 */
function resource(path, { deletable = false } = {}) {
  const calls = {
    list: async (params) => (await apiClient.get(path, { params })).data,
    retrieve: async (id) => (await apiClient.get(`${path}${id}/`)).data,
    create: async (payload) => (await apiClient.post(path, payload)).data,
    update: async (id, payload) => (await apiClient.patch(`${path}${id}/`, payload)).data,
  };

  if (deletable) {
    calls.remove = async (id) => {
      await apiClient.delete(`${path}${id}/`);
    };
  }

  return calls;
}

export const clientsApi = resource("/directory/clients/");
export const caregiversApi = resource("/directory/caregivers/", { deletable: true });
